/**
 * This file contains user information service that is shared 
 * accross the entier app
 * Provided at root level
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { User } from '../shared/models';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    private userInfo = new BehaviorSubject<User>(null);
    userInfo$ = this.userInfo.asObservable();
    private currentUser: User = null;

    /**
     * Emit Subject event
     * @param data User Info
     */
    sendUser(data: User): void {
        this.currentUser = data;
        this.userInfo.next(data);
    }

    /**
     * Get current user info
     * @returns User
     */
    getUserInfo() {
        return this.currentUser ?? null;
    }

    private apiTokenClaims: Record<string, unknown> | null = null;

    /**
     * The Zeymo claims of the latest Zeymo API access token. Under External ID they exist only
     * there, not on the ID token (ZEY-3138).
     */
    setApiTokenClaims(claims: Record<string, unknown>): void {
        this.apiTokenClaims = claims;
    }

    getApiTokenClaims(): Record<string, unknown> | null {
        return this.apiTokenClaims;
    }

}